// TAPINTO® Editor Frontend - Toolbar Component
// Version: 1.0
// Date: 2025-10-01

import React from 'react';
import { 
  Save, 
  Eye, 
  Download, 
  Undo, 
  Redo, 
  Settings, 
  Image,
  Type,
  Square,
  Layout
} from 'lucide-react';
import { Button } from '../common/Button';
import { useEditorStore } from '../../stores/editorStore';

export function Toolbar() {
  const { 
    isDirty, 
    isSaving, 
    isPublishing, 
    savePage, 
    publishPage 
  } = useEditorStore();

  const handleSave = () => {
    savePage();
  };

  const handlePublish = () => {
    publishPage();
  };

  const handlePreview = () => {
    // Open preview in new tab
    window.open('/preview', '_blank');
  };

  const handleExport = () => {
    // Export page data
    console.log('Export page');
  };

  return (
    <div className="bg-white border-b border-neutral-200 px-4 py-2">
      <div className="flex items-center justify-between">
        {/* Left side - Action buttons */}
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleSave}
            disabled={!isDirty || isSaving}
          >
            <Save className="h-4 w-4 mr-1" />
            {isSaving ? 'Saving...' : 'Save'}
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={handlePublish}
            disabled={isPublishing}
          >
            <Eye className="h-4 w-4 mr-1" />
            {isPublishing ? 'Publishing...' : 'Publish'}
          </Button>
          
          <div className="w-px h-6 bg-neutral-200 mx-2" />
          
          <Button
            variant="ghost"
            size="sm"
            onClick={handlePreview}
          >
            <Eye className="h-4 w-4 mr-1" />
            Preview
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={handleExport}
          >
            <Download className="h-4 w-4 mr-1" />
            Export
          </Button>
        </div>

        {/* Center - Component quick actions */}
        <div className="flex items-center space-x-1">
          <Button
            variant="ghost"
            size="sm"
            title="Add Text"
          >
            <Type className="h-4 w-4" />
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            title="Add Image"
          >
            <Image className="h-4 w-4" />
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            title="Add Shape"
          >
            <Square className="h-4 w-4" />
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            title="Add Layout"
          >
            <Layout className="h-4 w-4" />
          </Button>
        </div>

        {/* Right side - Settings and history */}
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            title="Undo"
          >
            <Undo className="h-4 w-4" />
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            title="Redo"
          >
            <Redo className="h-4 w-4" />
          </Button>
          
          <div className="w-px h-6 bg-neutral-200 mx-2" />
          
          <Button
            variant="ghost"
            size="sm"
            title="Settings"
          >
            <Settings className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
